import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play_circle",
  "use": "play_circle-usage",
  "viewBox": "0 0 72 72",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 72 72\" id=\"play_circle\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"36\" cy=\"36\" r=\"36\" fill=\"#FFF\" opacity=\".87\" /><path fill=\"#FC766A\" stroke=\"#FC766A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"4\" d=\"M28 22l22 14-22 14z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol